import {
  faStar
} from '@fortawesome/free-regular-svg-icons';

export const iconsRegular = {
  ratingStar: faStar
};
